// components/MenuItemsTable/FilterBar.js
import React from 'react';

const FilterBar = ({
  searchTerm,
  setSearchTerm,
  isVegSelected,
  setIsVegSelected,
  isNonVegSelected,
  setIsNonVegSelected,
  selectedCategory,
  setSelectedCategory,
  discountFilter,
  setDiscountFilter,
  couponFilter,
  setCouponFilter,
  onClearFilters
}) => {
  const hasActiveFilters = searchTerm || isVegSelected || isNonVegSelected || 
    selectedCategory !== "ALL" || discountFilter !== "Offers" || couponFilter !== "Coupons";

  return (
    <div className="menu-filter-wrapper">
      <div className="menu-filter-bar">
        <div className="menu-filter-left">
          <div className="menu-filter-label">Filters</div>
          {hasActiveFilters && (
            <button className="menu-clear-btn" onClick={onClearFilters}>
              ✕ Clear
            </button>
          )}
        </div>
        <div className="menu-filter-right">
          <select 
            className="menu-select" 
            value={discountFilter} 
            onChange={e => setDiscountFilter(e.target.value)}
          >
            <option value="Offers">Offers</option>
            <option value="10% OFF">10% OFF</option>
            <option value="20% OFF">20% OFF</option>
            <option value="30% OFF">30% OFF</option>
            <option value="50% OFF">50% OFF</option>
          </select>
          
          <select 
            className="menu-select" 
            value={couponFilter} 
            onChange={e => setCouponFilter(e.target.value)}
          >
            <option value="Coupons">Coupons</option>
            <option value="FREEDEL">FREEDEL</option>
            <option value="SAVE20">SAVE20</option>
            <option value="WELCOME50">WELCOME50</option>
          </select>
          
          <input 
            type="text" 
            placeholder="Search dish..." 
            value={searchTerm} 
            onChange={e => setSearchTerm(e.target.value)} 
            className="menu-search" 
          />
          
          <div 
            className={`menu-chip veg ${isVegSelected ? "active" : ""}`} 
            onClick={() => {
              setIsVegSelected(!isVegSelected);
              setIsNonVegSelected(false);
            }}
          >
            🌱 Veg
          </div>
          
          <div 
            className={`menu-chip nonveg ${isNonVegSelected ? "active" : ""}`} 
            onClick={() => {
              setIsNonVegSelected(!isNonVegSelected);
              setIsVegSelected(false);
            }}
          >
            🍗 Non-Veg
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;